import React from 'react';

import defaultImage from '../../assets/images/default-avatar.png';
import {Grid} from "@mui/material";

const sxStyle = {
    pictureGrid: {
        width: '130px',
        height: '130px',
        backgroundColor: '#999999',
        border: '1px solid lightgray',
        color: '#FFFFFF',
        borderRadius: '50%',
        margin: '5px auto',
        overflow: 'hidden',
        transition: 'all 0.2s',
        webkitTransition: 'all 0.2s',
        "&:hover": {
                    borderColor: '#2ca8ff'
                }
    }
}

class PictureUpload extends React.Component{
    constructor(props){
        super(props);
        this.state = {
          changed: false,
          file: null,
          imagePreviewUrl: props.imgSrc || defaultImage
        };
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
      this.setState({ imagePreviewUrl: this.props.imgSrc || defaultImage });
    }

    handleImageChange(e){
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (!file) {
          return;
        }
        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        }
        reader.readAsDataURL(file);
        if(this.props.onFileChange) {
          this.props.onFileChange(file);
        }
        this.setState({ changed: true });
    }
    handleSubmit(e){
        e.preventDefault();
        // this.state.file is the file/image uploaded
        // in this function you can save the image (this.state.file) on form submit
        // you have to call it yourself
    }



    render(){
      if(!this.state.changed && this.state.imagePreviewUrl != this.props.imgSrc) {
        this.setState({ imagePreviewUrl: this.props.imgSrc });
      }
      return(
          <Grid>
                <Grid item container sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center',
                    position: 'relative',
                    cursor: 'pointer',
                    textAlign: 'center' }} lg={12} xl={12}>

                    <Grid item container sx={{...sxStyle.pictureGrid, display: 'flex', justifyContent: 'center', m:0,p:0}}  >
                        <img src={this.state.imagePreviewUrl || defaultImage} style={{ width: '100%'}} alt="..."/>
                        <input type="file" style={{ opacity: 0,  display: "block",  height: '100%', left: 0, top: 0, position: 'absolute', width: '100%' }}  onChange={(e) => this.handleImageChange(e)}/>
                    </Grid>

                        {!this.state.imagePreviewUrl &&
                           <Grid item sx={{ m:0, p:0}} lg={12} xl={12}>
                                <h6 className="description">ADICIONAR</h6>
                           </Grid>
                        }


                </Grid>
              <Grid item lg={12} xl={12}>
                  {this.state.imagePreviewUrl &&
                      <Grid item lg={12} xl={12}>
                          <h6 style={{ textAlign: 'center' }}>
                              <a href={this.state.imagePreviewUrl} target='_blank' className='description'>
                                  VER IMAGEM
                              </a>
                          </h6>
                      </Grid>}
              </Grid>
          </Grid>
      );
    }
}

export default PictureUpload;
